import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ITaskNoteList, TaskNote } from '../models/task-note';
import { BaseRestService } from './base-rest.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root'})
export class TaskNoteService extends BaseRestService<TaskNote, ITaskNoteList>{

  constructor(http: HttpClient, protected router: Router) {
    super(TaskNoteService, http, 'api/tasknotes', 'task note', router);

    // enable caching
    this.cacheEnabled = false;
  }

  getNotes(taskUid: string, type?: string): Observable<TaskNote[]>{
    const url = taskUid + '/' + ((type) ? type : 'all');
    return this.getAllData(url);
  }

  save(note, successMessage?: string) {
    super.save(note as TaskNote, successMessage);
  }
}
